module.exports = __webpack_public_path__ + "static/media/header_eventd90ccf530400cc44c2516acb9d8e7e73.webp";